<template>
  <div class="body"></div>
  <div v-for="item in items" :key="item.plan">
    <RoomCard :item="item" @catchReserveClick="reserveClick"></RoomCard>
  </div>
</template>

<script>
import RoomCard from './RoomCard.vue'
import Const from '../const'
import axios from 'axios'
import authMixin from '../mixins/authMixin'

export default {
  name: 'RoomList',
  components: {
    RoomCard,
  },

  data: () => ({
    items: [],
  }),
  methods: {
    reserveClick: function() {
      this.$router.push({ name: 'reserveRoom' });
    },
    getPlan: function() {
      // プラン取得APIの実行
      axios.get(Const.BASE_URL + "/plan",
        {
          headers: {
            "Authorization": this.$store.getters.token,
            "Content-Type": "application/json"
          }
        }
      ).then((res) => {
        this.items = res.data.Items.sort((a, b) => a.sort > b.sort ? 1 : -1);
      }).catch(function() {
        // console.log(error)
        // this.$router.push({ name: "forbidden" })
      });
    }
  },
  mounted() {
    this.getPlan();
  },
  mixins: [authMixin]
}
</script>

<style scoped>
.body {
  padding-top: 70px;
}
</style>